import { TransactionDisplayData } from '../types/models'

export const TRANSACTION_DISPLAY_DATA = 'transactionDisplayData'

export function setTransactionInLocalStorage(
  transactionDetails: TransactionDisplayData,
) {
  return localStorage.setItem(
    TRANSACTION_DISPLAY_DATA,
    JSON.stringify(transactionDetails),
  )
}

export function isValidTransactionData(
  input: unknown,
): input is TransactionDisplayData {
  return (
    input != null &&
    typeof input === 'object' &&
    'currency' in input &&
    'orderTotal' in input &&
    'subTotal' in input &&
    'totalTax' in input &&
    'retailDeliveryFee' in input &&
    'shippingCost' in input
  )
}

export function parseTransactionFromJson(
  input: string | null,
): TransactionDisplayData | undefined {
  if (input) {
    try {
      const parsedTransaction: unknown = JSON.parse(input)
      if (isValidTransactionData(parsedTransaction)) {
        return parsedTransaction
      }
    } catch {
      return
    }
  }
}

export function getTransactionFromLocalStorage():
  | TransactionDisplayData
  | undefined {
  const retrievedTransaction = localStorage.getItem(TRANSACTION_DISPLAY_DATA)
  return parseTransactionFromJson(retrievedTransaction)
}

export const clearTransactionFromLocalStorage = () => {
  return localStorage.removeItem(TRANSACTION_DISPLAY_DATA)
}
